import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { selectSuccess } from '_store/oauth/selector';
import { authenticate } from '_store/oauth/slice';
import { selectActiveOrderId } from '_store/order/selector';
import { selectActiveMainProductId } from '_store/order/selector';
import { getOrder, restoreActiveOrderId } from '_store/order/slice';
import { selectCustomerId } from '_store/user/selector';

import Spinner from 'components/atomic/Spinner';
import Text from 'components/atomic/layouts/Text';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${theme.colors.linkWater};
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spaces.regular}px;
`;

const OAuthCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const orderId = useSelector(selectActiveOrderId);
  const productId = useSelector(selectActiveMainProductId);
  const success = useSelector(selectSuccess);

  useEffect(() => {
    if (customerId && productId && code && state) {
      dispatch(
        authenticate({
          customerId,
          productId,
          code,
          state,
          redirectUrl: `${window.location.origin}${window.location.pathname}`,
        })
      );
    }
  }, [customerId, productId, code, state]);

  useEffect(() => {
    if (customerId && orderId) {
      dispatch(getOrder({ customerId, orderId }));
    }
  }, [customerId, orderId]);

  useEffect(() => {
    if (success) {
      navigate('../main');
    }
  }, [success]);

  useEffect(() => {
    dispatch(restoreActiveOrderId());
  }, []);

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Spinner />
        <Text color={theme.colors.gray.secondary}>Redirecting...</Text>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default OAuthCallbackPage;
